export enum EnumFiltrarPor {
    DATA_PAGAMENTO = 0,
    DATA_VENCIMENTO = 1,
}